import { render, staticRenderFns } from "./section-favorites.vue?vue&type=template&id=5777ef41&scoped=true&"
import script from "./section-favorites.vue?vue&type=script&lang=js&"
export * from "./section-favorites.vue?vue&type=script&lang=js&"
import style0 from "./section-favorites.vue?vue&type=style&index=0&id=5777ef41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5777ef41",
  null
  
)

export default component.exports